
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PosmDemandComponent } from './posm-demand.component';
import { PosmDemandRoutingModule } from './posm-demand-routing.module';
import { DemandFormComponent } from './demand-form/demand-form.component';
import { PartialsModule } from '@app/views/partials/partials.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatButtonModule, MatCardModule, MatCheckboxModule, MatDatepickerModule, MatDialogModule, MatDividerModule, MatExpansionModule, MatFormFieldModule, MatGridList, MatGridTile, MatIconModule, MatInputModule, MatMenuModule, MatNativeDateModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatSelectModule, MatSnackBarModule, MatSortModule, MatTableModule, MatTabsModule, MatTooltipModule, MatTreeModule } from '@angular/material';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CoreModule } from '@app/core/core.module';

import { DirectiveModule } from '../shared/directives/directive.module';
import { ProductPhotoComponent } from '../common-components/product-photo/product-photo.component';
import { AutocompleteComboComponent } from '../common-components/autocomplete-combo/autocomplete-combo.component';
import { DemandListComponent } from './demand-list/demand-list.component';
import { SharedModule } from '@shared/shared.module';
import { AdminModule } from '../admin/admin.module';
import { CommonComponentModule } from '../common-components/common-component.module';

@NgModule({
	declarations: [PosmDemandComponent, DemandFormComponent, DemandListComponent],
  imports: [
    PosmDemandRoutingModule,
    CommonModule,
    CoreModule,

    PartialsModule,
	
		DragDropModule,
		FormsModule,
		ReactiveFormsModule,

		MatFormFieldModule,
		MatInputModule,
		MatTableModule,
		MatPaginatorModule,
		MatSortModule,
		MatProgressSpinnerModule,
		MatSelectModule,
		MatIconModule,
		MatButtonModule,
		MatCheckboxModule,

		MatMenuModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatSnackBarModule,
		MatExpansionModule,
		MatTabsModule,
		MatTooltipModule,
		MatDialogModule,
		MatDividerModule,
		MatTreeModule,
	
		NgxMatSelectSearchModule,

		DirectiveModule,
		CommonComponentModule,
		
	],

  entryComponents: [
	ProductPhotoComponent,
  ]
  
})
export class PosmDemandModule { }
